import { render } from "./youtube.vue?vue&type=template&id=35331bc8"
import script from "./youtube.vue?vue&type=script&lang=js"
export * from "./youtube.vue?vue&type=script&lang=js"

import "./youtube.vue?vue&type=style&index=0&id=35331bc8&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/videos/_components/youtube.vue'],['render',render],['__file',"youtube.vue"]])

export default __exports__